document.addEventListener('DOMContentLoaded', function() {
  let currentlyVisibleTag = null;
  let currentlyVisibleWrapper = null;

  const pulses = document.querySelectorAll('.product-indicator');
  const section = document.querySelector('.banner-scene-section');

  function showTag(wrapper) {
    const productTag = wrapper.querySelector('.product_tag');

    if (currentlyVisibleTag && currentlyVisibleTag !== productTag) {
      currentlyVisibleTag.style.display = 'none';
    }

    productTag.style.display = 'block';
    currentlyVisibleTag = productTag;
    currentlyVisibleWrapper = wrapper;
  }

  function hideTag(wrapper) {
    const productTag = wrapper.querySelector('.product_tag');
    productTag.style.display = 'none';

    if (currentlyVisibleTag === productTag) {
      currentlyVisibleTag = null;
      currentlyVisibleWrapper = null;
    }
  }

  pulses.forEach(pulse => {
    const wrapper = pulse.parentElement;

    wrapper.addEventListener('mouseenter', function() {
      showTag(wrapper);
    });

    wrapper.addEventListener('mouseleave', function() {
      hideTag(wrapper);
    });

    pulse.addEventListener('click', function(e) {
      e.stopPropagation();
      const productTag = wrapper.querySelector('.product_tag');

      if (currentlyVisibleTag === productTag) {
        hideTag(wrapper);
      } else {
        showTag(wrapper);
      }
    });
  });

  if (section) {
    section.addEventListener('click', function() {
      if (currentlyVisibleTag) {
        currentlyVisibleTag.style.display = 'none';
        currentlyVisibleTag = null;
        currentlyVisibleWrapper = null;
      }
    });
  }
});